import { Card, CheckboxCard, Stack, Text } from 'ui';

import classes from './OnboardingIntentModal.module.css';
import { IntentOption, OnboardingIntentForms } from './types';

interface IntentSelectionProps<TForm extends OnboardingIntentForms['supportForm']> {
  options: IntentOption[];
  title?: string;
  getInputProps: TForm['getInputProps'];
}

export const IntentSelection = <TForm extends OnboardingIntentForms['supportForm']>({
  options,
  title,
  getInputProps,
}: IntentSelectionProps<TForm>) => {
  return (
    <Stack gap="md" mb="md">
      {title && (
        <Text fw={600} fz="lg" c="gray.8">
          {title}
        </Text>
      )}
      <Card withBorder radius="md" className={classes.intentCard}>
        {options.map((option) => (
          <CheckboxCard
            key={option.key}
            description={option.description}
            title={option.title}
            c="gray.8"
            position="right"
            bg="transparent"
            {...getInputProps(option.key, { type: 'checkbox' })}
            className={classes.intentCheckboxCard}
          />
        ))}
      </Card>
    </Stack>
  );
};
